import { Link } from 'react-router-dom';
import { Dashboard } from '@/components/dashboard/Dashboard';
import { Button } from '@/components/ui/Button';
import { Badge } from '@/components/ui/misc';
import { SAMPLE_RUN } from '@/lib/sampleRun';
import { ArrowRight } from 'lucide-react';

export function SampleReport() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
      <div className="mb-6 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <Badge tone="blue" className="mb-2">
            Sample report
          </Badge>
          <h1 className="text-3xl font-bold tracking-tight text-text-primary">
            {SAMPLE_RUN.project.brandName} — AI visibility
          </h1>
          <p className="mt-1 text-sm text-text-secondary">
            An example of the dashboard you get after running an analysis. Data shown here is
            illustrative.
          </p>
        </div>
        <Link to="/analyze">
          <Button>
            Analyze your website <ArrowRight size={16} />
          </Button>
        </Link>
      </div>
      <Dashboard run={SAMPLE_RUN} />
    </div>
  );
}
